import CLPViewState from '../../store/schema/clp/CLPViewState';
import CLPAuditAction, {
    CLPAuditActionRequestBody,
    CLPAuditPlatform,
    CLPAuditTargetLocation,
} from '../../store/schema/clp/CLPAuditAction';
import { getAccessTokenforResource } from 'owa-tokenprovider';
import { isDogfoodEnv } from 'owa-metatags';

const AUDIT_RESOURCE_URL =
    'https://o365auditrealtimeingestion.manage.office.com:445/api/userauditrecord';

const AUDIT_RESOURCE_PPE_URL =
    'https://o365auditrealtimeingestion.manage.officeppe.com:445/api/userauditrecord';

export default function sendCLPAuditRequest(viewState: CLPViewState) {
    const { auditActionStack } = viewState;
    const tokenPromise = getAccessTokenforResource(AUDIT_RESOURCE_URL);
    const auditUrl = isDogfoodEnv() ? AUDIT_RESOURCE_PPE_URL : AUDIT_RESOURCE_URL;
    tokenPromise.then(token => {
        auditActionStack.forEach((auditAction: CLPAuditAction) => {
            const requestBody = constructRequestBody(auditAction);
            const endpoint = `${auditUrl}/Post${auditAction.logType as string}Log`;
            fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(requestBody),
            });
        });
    });
}

function constructRequestBody(auditAction: CLPAuditAction): CLPAuditActionRequestBody {
    return {
        ...auditAction,
        application: 'OWA',
        platform: CLPAuditPlatform.WebBrowser, // This is a server side enum, 5 is web browser, so it's always 5 for us.
        deviceName: window.location.host, // For OWA device name is host name.
        targetLocation: CLPAuditTargetLocation.Cloud,
    };
}
